import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../contexts/AuthContext';

// importa o SVG como componente (CRA/SVGR)
import { ReactComponent as Logo } from '../assets/logo.svg';

export default function TopBar({ onMenuClick }) {
  const { logout } = useAuth();

  return (
    <AppBar
      position="fixed"
      elevation={1}
      sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}
    >
      <Toolbar>
        {/* Hambúrguer: visível apenas em telas < md */}
        <IconButton
          color="inherit"
          edge="start"
          aria-label="menu"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { xs: 'inline-flex', md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Logo */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <Logo style={{ height: 70, width: 'auto', display: 'block',color: '#fff' }} />
          {/* opcional: texto ao lado do logo
          <Typography sx={{ ml: 1, fontWeight: 800 }}>GoldSafe</Typography>
          */}
        </Box>

        <Button color="inherit" onClick={logout}>Sair</Button>
      </Toolbar>
    </AppBar>
  );
}
